// =============================================================================
// DHL Tracking Types
// =============================================================================

export interface DhlTrackingAddress {
  countryCode: string | null;
  postalCode: string | null;
  addressLocality: string | null;
}

export interface DhlTrackingEvent {
  timestamp: string | null;
  location: string | null;
  address: DhlTrackingAddress | null;
  description: string;
  statusCode: string;
}

export interface DhlTrackingStatus {
  timestamp: string | null;
  location: string | null;
  statusCode: string;
  description: string;
}

export interface DhlTrackingShipment {
  id: string;
  service: string | null;
  origin: DhlTrackingAddress | null;
  destination: DhlTrackingAddress | null;
  status: DhlTrackingStatus | null;
  estimatedDeliveryDate: string | null;
  actualDeliveryDate: string | null;
  events: DhlTrackingEvent[];
}

// =============================================================================
// DHL Rate Types
// =============================================================================

export interface DhlRateResult {
  productName: string;
  productCode: string;
  price: number;
  currency: string;
  estimatedDeliveryDate: string | null;
}

// =============================================================================
// DHL Service Point Types
// =============================================================================

export interface DhlServicePoint {
  name: string;
  distance: number;
  address: {
    street: string | null;
    city: string | null;
    postalCode: string | null;
    countryCode: string;
    latitude: number | null;
    longitude: number | null;
  };
  serviceTypes: string[];
}

// =============================================================================
// Helpers
// =============================================================================

export function getDhlTrackingUrl(trackingNumber: string): string {
  return `https://www.dhl.com/ca-en/home/tracking/tracking-express.html?submit=1&tracking-id=${encodeURIComponent(trackingNumber)}`;
}
